import { useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import PropTypes from "prop-types";

import { dispatch } from "../../../state/store";
import {
  setIsFeaturesActive,
  setManageType,
  setPrevAppType,
  setSelectedApp
} from "../../../state/ducks";

import { groupsService, t } from "../../../services";
import { appManageTypes, colors, routePaths, strCode } from "../../../consts";

import {
  DropdownInput,
  FlexContainers,
  Heading6,
  Modal,
  Paragraph2,
  SmallButton,
  WrapperContainer
} from "../../../components";
import { CreateFromAppModalContainer } from "./styled";

const CreateFromAppModal = ({ isActive, setActive }) => {
  const history = useHistory();

  const apps = useSelector((store) => store.apps?.apps);
  const appsMarkets = useSelector((store) => store.apps?.appsMarkets);

  const [dropdownApp, setDropdownApp] = useState(null);

  const appsOptions = useMemo(() => {
    if (!apps) {
      return [];
    }

    return apps
      .map((app) => {
        return {
          id: app.name,
          value: app.name
        };
      })
      .sort((firstApp, secondApp) => firstApp.id.localeCompare(secondApp.id));
  }, [apps]);

  const onSelectApp = (appId) => {
    const app = appsOptions.find((a) => a.id === appId);

    setDropdownApp(app);
  };

  const onConfirmSelect = async () => {
    const confirmedApp = apps.find((app) => app.name === dropdownApp.id);
    const appName = Object.keys(appsMarkets).find((item) => item === confirmedApp.appType);

    const group = await groupsService.fetchSelectedGroup(confirmedApp.appType);

    dispatch(setPrevAppType(confirmedApp.appType));

    delete confirmedApp.appType;
    delete confirmedApp.name;
    delete confirmedApp.link;

    dispatch(setIsFeaturesActive(confirmedApp.defaultSettings.length > 0));
    dispatch(setManageType(appManageTypes.FROM_EXISTING));
    dispatch(
      setSelectedApp({
        ...confirmedApp,
        marketConfigs: appsMarkets[appName],
        groupConfigs: group,
        emailMessage: confirmedApp.emailMessage || "",
        localizations: []
      })
    );

    history.push(routePaths.CREATE_APP);
  };

  return (
    <Modal
      active={isActive}
      setActive={setActive}
      closable={false}
      Container={CreateFromAppModalContainer}
      preventOverflow
      modalHeader={<Heading6>{t(strCode.NEW_APP_TITLE)}</Heading6>}
      modalFooter={
        <WrapperContainer Container={FlexContainers.FlexRowEnd} width="100%" gap={8}>
          <SmallButton onClick={() => setActive()} secondary>
            {t(strCode.CANCEL_BTN)}
          </SmallButton>

          <SmallButton onClick={onConfirmSelect}>{t(strCode.CONTINUE_BTN)}</SmallButton>
        </WrapperContainer>
      }>
      <WrapperContainer Container={FlexContainers.FlexColumnStart} maxWidth={497} gap={24}>
        <Paragraph2 style={{ color: colors.RAISIN_70 }}>
          {t(strCode.APPLICATION_FROM_EXISTING)}
        </Paragraph2>

        <DropdownInput
          onSelectOption={onSelectApp}
          selectedOption={dropdownApp}
          options={appsOptions}
          title={t(strCode.SELECT_APP_PLACEHOLDER)}
          placeholder={t(strCode.SELECT_APP_PLACEHOLDER)}
          id="create-from-app-dropdown"
        />
      </WrapperContainer>
    </Modal>
  );
};

CreateFromAppModal.propTypes = {
  isActive: PropTypes.bool.isRequired,
  setActive: PropTypes.func.isRequired
};

export default CreateFromAppModal;
